export default __webpack_public_path__ + "static/media/480_dummy2016-architekturbuero01-monbile-de.560e1c00.png";